import { Box, Flex, Text } from '@chakra-ui/react';
import FileComponent from './FileComponent';
import { IEarlyAssessmentEditorialRequest } from '@publishing-engine/domain/models';

export const InvitationMessage: React.FC<{ editorialRequest: IEarlyAssessmentEditorialRequest }> = ({ editorialRequest }) => (
  <Flex
    padding={4}
    flexDirection="column"
    gap={3}
  >
    <Box>
      <Text textStyle="headingGroup">Invitation</Text>
      <Text textStyle={'textBody'}>We invite you to assess this submission and provide an informed recommendation on its suitability. Your expertise is essential to guide editors in making well-informed decisions. The Editors also left the following message:
      </Text>
    </Box>
    <Box>
      <Text textStyle="headingItem">Note from the Editor</Text>
      <Text textStyle={'textBody'}>{editorialRequest.comment}</Text>
      {editorialRequest?.attachments && editorialRequest?.attachments?.length > 0 && (
        <Flex flexDirection="column" gap={4} marginY={3}>
          <Text textStyle={'headingItem'}>Attached Files</Text>
          {editorialRequest.attachments.map(file => (
            <FileComponent file={file} />
          ))}
        </Flex>
      )}
    </Box>
  </Flex>
)

